// ** React Imports
import { Fragment, useContext } from "react"
import { Sun, Moon, Menu } from "react-feather"
import { NavItem, NavLink, UncontrolledTooltip } from "reactstrap"

import NavbarUser from "./NavbarUser"
import YearDropDown from './YearDropDown'
// import NotificationDropdown from "./NotificationDropdown"
import { MuiNotification } from '@student_components/MuiNotification'
import LanguageDropdown from "./LanguageDropdown"

import { AuthContext } from "@context/AuthContext";

import useApi from '@hooks/useApi';

import hrsvg from './hr2.png'

const ThemeNavbar = (props) => {
    // ** Props
    const { skin, setSkin, setMenuVisibility } = props

    const { userDetail } = useContext(AuthContext);

    // ** Function to toggle Theme (Light/Dark)
    const ThemeToggler = () => {
        if (skin === "dark") {
            return <Sun className="ficon" onClick={() => setSkin("light")} />
        } else {
            return <Moon className="ficon" onClick={() => setSkin("dark")} />
        }
    }

    const { instance } = useApi()

    return (
        <Fragment>
            <div className="bookmark-wrapper d-flex align-items-center me-1">
                <ul className="navbar-nav d-xl-none">
                    <NavItem className="mobile-menu me-auto">
                        <NavLink
                            className="nav-menu-main menu-toggle hidden-xs is-active"
                            onClick={() => setMenuVisibility(true)}
                        >
                            <Menu className="ficon" />
                        </NavLink>
                    </NavItem>
                </ul>
                <NavItem className="d-block">
                    <NavLink className="nav-link-style">
                        <ThemeToggler />
                    </NavLink>
                </NavItem>
                <ul className="nav navbar-nav align-items-center">
                    <YearDropDown />
                </ul>
            </div>
            <ul className="nav navbar-nav align-items-center ms-auto">
                <a href={`${process.env.REACT_APP_MUIS_HR_URL}/account/from-another-website/${userDetail.hashed_id}/uZ1qp6PUiBa6KQPn0Qi4/`} target="_blank" className="me-25">
                    <img id="human-resource-img" src={hrsvg} width={25} alt="human-resource" />
                </a>
                <UncontrolledTooltip
                    placement="top"
                    target="human-resource-img"
                >
                    Хүний нөөцийн систем-рүү орох
                </UncontrolledTooltip>
                <LanguageDropdown/>
                {/* <MuiNotification
                    instance={instance}
                /> */}
                <NavbarUser skin={skin} setSkin={setSkin} />
            </ul>
        </Fragment>
    )
}

export default ThemeNavbar
